import { render, staticRenderFns } from "./GuidelineToolbar.vue?vue&type=template&id=b2d58d2a&scoped=true&"
import script from "./GuidelineToolbar.vue?vue&type=script&lang=ts&"
export * from "./GuidelineToolbar.vue?vue&type=script&lang=ts&"
import style0 from "./GuidelineToolbar.vue?vue&type=style&index=0&id=b2d58d2a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2d58d2a",
  null
  
)

export default component.exports